// extracted by mini-css-extract-plugin
export default {"panelButton":"FeaturePanelOpenButton_panelButton__OKrL+"};